import { requiredValidator } from '../../required'

export const ReduxFormRequired = value => requiredValidator(value) ? undefined : 'Error'
